<template>
  <card class="col-12">
    <h4 class="title"><translate>Contacts</translate></h4>
    <div class="card-content">
      <ul class="list-unstyled team-members">
        <li>
          <div class="row" v-for="contact in contacts">
            <div class="col-xs-12" v-if="contact.type !== 'description'">
              <div class="icon-container" >
                <span :class="contact.icon"></span>
                <span class="icon-name"><a :target="contact.target" :href="contact.href">{{contact.value}}</a></span>
              </div>
            </div>
            <div class="col-xs-12" v-else-if="contact.value !== null"><nl2br tag="p" :text="contact.value"/></div>
            <!--<div class="col-xs-3" v-if="contact.type !== 'description'">-->
              <!--<div class="avatar">-->
                <!--<img :src="member.image" alt="Circle Image" class="img-circle img-no-padding img-responsive">-->
              <!--</div>-->
            <!--</div>-->
            <!--<div class="col-xs-9">-->
              <!--{{contact.value}}-->
              <!--&lt;!&ndash;<br>&ndash;&gt;-->
              <!--&lt;!&ndash;<span :class="getStatusClass(member.status)">&ndash;&gt;-->
                <!--&lt;!&ndash;<small>{{member.status}}</small>&ndash;&gt;-->
              <!--&lt;!&ndash;</span>&ndash;&gt;-->
            <!--</div>-->
          </div>
        </li>
      </ul>
    </div>
  </card>
</template>
<script>
  import Nl2br from 'vue-nl2br'
  import Card from 'src/components/UIComponents/Cards/Card'

  export default {
    created () {
      this.contacts.map(contact => {
        switch (contact.type) {
          case 'phone':
            contact.icon = 'fa fa-phone'
            contact.href = `tel:${contact.value.replace(' ', '', -1)}`
            contact.target = '_self'
            break
          case 'email':
            contact.icon = 'fa fa-envelope'
            contact.href = `mailto:${contact.value}`
            contact.target = '_self'
            break
          case 'site':
            contact.icon = 'fa fa-globe'
            if (/^https?:\/\//.test(contact.value)) {
              contact.href = contact.value
            } else {
              contact.href = `http://${contact.value}`
            }
            contact.target = '_blank'
            break
        }
      })
    },
    components: {
      Nl2br,
      Card
    },
    props: {
      contacts: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        title: 'Team members',
        members: [
          {
            image: 'static/img/faces/face-0.jpg',
            name: 'Dj Khaled',
            status: 'Offline'
          },
          {
            image: 'static/img/faces/face-1.jpg',
            name: 'Creative Tim',
            status: 'Available'
          },
          {
            image: 'static/img/faces/face-3.jpg',
            name: 'Flume',
            status: 'Busy'
          }
        ]
      }
    },
    methods: {
      getStatusClass (status) {
        switch (status) {
          case 'Offline':
            return 'text-muted'
          case 'Available':
            return 'text-success'
          case 'Busy':
            return 'text-danger'
          default:
            return 'text-success'
        }
      }
    }
  }

</script>
<style>

</style>
